import {
  AfterViewInit,
  Directive,
  ElementRef,
  Inject,
  Input,
  Renderer2,
} from '@angular/core';
import { DataService } from '../../services/data/data.service';

@Directive({
  selector: '[appLicensed]',
})
export class LicensedDirective implements AfterViewInit {
  @Input() appLicensed: any;
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    @Inject(DataService) private data: DataService
  ) {}

  ngAfterViewInit(): void {
    if (!this.existsLicense(this.appLicensed)) {
      this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
    }
  }

  existsLicense(url: string): boolean {
    const moduleURL = url.split('/')[1];
    return this.data.enabledMenuOpts.some(module => module.id === moduleURL);
  }
}
